import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useReviewRequest } from '@/hooks/useReviewRequest';

/**
 * Die Bitte um eine Bewertung, als ruhige Karte unter der Handlungskarte des
 * Feed-Checks (Spec 2026-09-05, E14). Kein Modal, kein Overlay, keine Animation,
 * kein Gradient: shadcn-Card mit Tokens. Rendert null, solange der Hook die
 * Karte nicht freigibt; nach Klick oder Dismiss verschwindet sie dauerhaft.
 *
 * Der Primaer-Knopf ist ein ANKER mit target=_blank (Button asChild), kein
 * window.open nach einem await: so bleibt die Navigation eine echte
 * Nutzergeste (kein Popup-Blocker), und onClick startet Marke + Tracking
 * nebenher. Die Seite bleibt offen, die Requests laufen zu Ende.
 */
export function ReviewRequestCard() {
  const { t } = useTranslation('optimization');
  const review = useReviewRequest();
  if (!review.visible) return null;
  const platform = t(`reviewRequest.platform.${review.platform}`);
  // Die Zeitangabe steht je Plattform im Katalog, nicht im Satz: OMR fuenf bis zehn
  // Minuten, G2 zehn bis fuenfzehn (Entscheidung Dennis 05.09.2026,
  // docs/review-leitfragen-2026-09-05.md). Eine gemeinsame Zahl waere fuer eine
  // der beiden Plattformen eine Falschaussage an der Stelle, an der jemand
  // entscheidet, ob er jetzt anfaengt.
  const minutes = t(`reviewRequest.minutes.${review.platform}`);
  return (
    <Card data-testid="review-request-card" className="print:hidden">
      <CardContent className="pt-6 pb-6 space-y-3">
        <h3 className="text-base font-semibold text-foreground">{t('reviewRequest.title')}</h3>
        <p className="text-sm text-muted-foreground">{t('reviewRequest.body', { platform, minutes })}</p>
        <div className="flex flex-wrap gap-2">
          <Button asChild size="sm">
            <a
              href={review.writeUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => { void review.markClicked(); }}
            >
              {t('reviewRequest.write', { platform })}
            </a>
          </Button>
          <Button variant="ghost" size="sm" onClick={() => { void review.dismiss(); }}>
            {t('reviewRequest.dismiss')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
